import { GLOBALS } from '../config'
import { UPDATE_UTILITIES } from '@actions/utilities'
import { addGlobalMessage } from '@api/global_messages'

const DEFAULTS = {
  credentials: 'include',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
}

const POST_DEFAULTS = {
  method: 'POST',
  ...DEFAULTS
}

const DELETE_DEFAULTS = {
  method: 'DELETE',
  ...DEFAULTS
}

const PUT_DEFAULTS = {
  method: 'PUT',
  ...DEFAULTS
}

export const post = (type, route, payload, callback, errorCb) => dispatch =>
  dispatch(api(type, route, getPayload(POST_DEFAULTS, payload, 'post'), callback, errorCb))
export const get = (type, route, callback, errorCb) => dispatch =>
  dispatch(api(type, route, getPayload(DEFAULTS, null, 'get'), callback, errorCb))
export const put = (type, route, payload, callback, errorCb) => dispatch =>
  dispatch(api(type, route, getPayload(PUT_DEFAULTS, payload, 'put'), callback, errorCb))
export const del = (type, route, payload, callback, errorCb) => dispatch =>
  dispatch(api(type, route, getPayload(DELETE_DEFAULTS, payload, 'delete'), callback, errorCb))

const getPayload = (defaults, payload, type) => ({
  ...defaults,
  ...getBody(payload, type)
})

const getBody = (payload, type) => (
  (type === "get" || !payload) ? {} : { body: JSON.stringify(payload) }
)

const PERMISSION_DENIED_MESSAGE = "You do not have permission to perform this action."

/**
 * The server rejects actions a user's role does not allow with a 401 or 403 and a message.
 * Only treat these as permission errors once authenticated, since 401 also means bad credentials on login.
 */
const isPermissionDenied = (status, getState) =>
  (status === 401 || status === 403) && getState().auth.status === "AUTHENTICATED"

const api = (type, route, payload, callback, errorCb) => (dispatch, getState) => {
  return dispatch({
    type,
    payload: new Promise((resolve, reject) =>
      fetch(GLOBALS.API_URL + '/' + route, payload).then(res => {
        const ok = res.ok
        const status = res.status
        res.json().catch(() => ({})).then(json => {
          if (ok) {
            dispatch({ type: UPDATE_UTILITIES, key: 'last_api_activity', value: Date.now() })
            if (callback && typeof callback === 'function') {
              callback(json)
            }
            resolve(json)
          }
          else {
            const errorPayload = { ...json, status }
            if (isPermissionDenied(status, getState)) {
              // Surface the server's reason instead of the caller's generic error message.
              dispatch(addGlobalMessage(json.message || json.error || PERMISSION_DENIED_MESSAGE, "error"))
            }
            else if (errorCb && typeof errorCb === 'function') {
              errorCb(errorPayload)
            }
            reject(errorPayload)
          }
        })
      })
      .catch(error => {
        if (errorCb && typeof errorCb === 'function') {
          errorCb(error)
        }
        reject(error)
      })
    )
  })
}
